import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";
import { Leaf } from "lucide-react";
import { useToast } from "../hooks/use-toast";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const { toast } = useToast();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    // Clear the hash from the URL immediately
    if (typeof window !== "undefined") {
      window.history.replaceState(null, "", window.location.pathname);
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setGoogleUser(res.data);
        toast({ title: "Signed in with Google", description: `Welcome, ${res.data.name}!` });
        navigate("/account", { replace: true });
      } catch (err) {
        toast({
          title: "Sign-in failed",
          description: err?.response?.data?.detail || "Please try again.",
          variant: "destructive",
        });
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, [location.hash, navigate, setGoogleUser, toast]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-green-50 to-white">
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-green-600 text-white flex items-center justify-center animate-pulse">
          <Leaf size={20} />
        </div>
        <p className="mt-4 text-neutral-700 font-semibold">Signing you in…</p>
        <p className="mt-1 text-sm text-neutral-500">One moment please.</p>
      </div>
    </main>
  );
}
